export default "__VITE_ASSET__07a31cbc__"